export default __webpack_public_path__ + "static/media/cross.5c090fe5.svg";